/* eslint-disable */
import React, { Component } from 'react';

import { Divider, Radio, Table } from 'antd';

import { getPolusCompetence } from '@/store/v2/v2';
import PropTypes from 'prop-types';

const { Column } = Table;

export class CompetenceList extends Component {
  static propTypes = {
    onSelectCompetence: PropTypes.func,
    currentUser: PropTypes.object,
    t: PropTypes.func,
  };

  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      competences: [],
    };
  }

  componentDidMount() {
    const { currentUser } = this.props;
    this.setState({ isLoading: true });
    getPolusCompetence(
      currentUser.id,
      res => {
        if (res && Array.isArray(res) && res.length) {
          let competencies = [];
          res.map(competence => {
            let object = {
              key: competence.id,
              name: competence.name,
              isHardSkill: competence.is_hard_skill,
            };

            competencies.push(object);
          });

          this.setState({
            competences: competencies,
          });
        }
      },
      err => {
        console.error('Error:', err.statusText);
      }
    );

    this.setState({ isLoading: false });
  }

  getTableData = () => {
    const [competences] = this.state;
    let data = [];

    if (Array.isArray(competences) && competences.length) {
      for (let i = 0; i < competences.length; i++) {
        let competence = competences[i];

        if (typeof competence === 'object') {
          let object = {
            key: competence.id,
            name: competence.name,
            skills: competence.skills || [],
            isHardSkill: competence.isHardSkill || false,
          };

          data.push(object);
        }
      }
    }

    return data;
  };

  handleChange = row => {
    if (typeof row === 'object' && typeof this.props.onSelectCompetence === 'function') {
      this.props.onSelectCompetence(row);
    }
  };

  render() {
    const { isLoading, competences } = this.state;
    const { t } = this.props;

    return (
      <>
        <Table
          ellipsis={true}
          bordered={false}
          style={{ width: '100%' }}
          loading={isLoading}
          dataSource={competences}
          pagination={{
            pageSize: 6,
            style: { padding: '1rem' },
          }}
          onSelect={this.handleChange}
          rowSelection={{
            type: 'radio',
            onSelect: this.handleChange,
          }}
        >
          <Column title={t('competence')} dataIndex='name' key='competencies' filterSearch={false} />
        </Table>
      </>
    );
  }
}

export default CompetenceList;
